import React from "react";
import { Route } from "react-router";
import ProjectDeadline from "./Custom/ProjectDeadline/ProjectDeadline";

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  <Route path="/project-deadline" component={ProjectDeadline} />
];
